import { getAnonymousUploads, getProductUploads } from "apis/storageApi";
import { doCall } from "common/genericSaga";
import { all, call, put, takeEvery } from "redux-saga/effects";
import {
  PRODUCT_UPLOAD_INFO_REQUESTED,
  PRODUCT_UPLOAD_INFO_REQUEST_FAILED,
  receiveProductUploadInfo
} from "./storageActions";

export function* doRequestProductUploads(action, requestInfo) {
  let result = yield call(getProductUploads, requestInfo, action.accountId, action.id);
  if (!result) result = yield call(getAnonymousUploads, requestInfo, action.id);
  yield put(receiveProductUploadInfo(action.id, result));
}

export function* watchStorage() {
  yield all([
    takeEvery(PRODUCT_UPLOAD_INFO_REQUESTED, doCall(doRequestProductUploads, PRODUCT_UPLOAD_INFO_REQUEST_FAILED))
  ]);
}
